import React, {Component, Fragment, useEffect, useState} from 'react'
import Counter from "../../../components/counter";
import ProgressBar from "@ramonak/react-progress-bar";
import {getDeviseSymbol} from "../../../../../i18n";

export default function ScreenBarPartner({context,campagneData,mini}){

    const partnerMontant=campagneData?.partnerMontant || 1

    const total=campagneData.stats.total.sum.total/partnerMontant


    let bonus=null
    let _objectif=campagneData.objectif
    if(_objectif<total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length>0){
        bonus=campagneData.bonus.find(b=>b>total)
        if(!bonus){
            bonus=campagneData.bonus.at(-1)
        }
    }
    if(bonus){
        _objectif=bonus
    }

    const percent=(_objectif>0 ? (total/_objectif)*100 : 0)
    const displayPercent=(Number(campagneData.objectif)>0 ? (total/campagneData.objectif)*100 : 0)
    let progressColor=campagneData.config?.primaryColor || "#13A0BB"
    let progressLabelColor="#000"

    let donorName=campagneData.config?.donorName || "M2"

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })


    return (
        <Fragment>
            <div className={"d-flex justify-content-around align-items-center"} style={{flexDirection: "column", gap: 0}}>

                <div style={{display:"flex",flexDirection:"row",height:"50vh",width:"100vw",justifyContent:"center"}}>
                    <span className={"screen-count-text2"} style={{marginTop: "0vh",width:"100%",textAlign:"center",fontFamily:"BioRhyme !important",fontSize:"30vh",color:"#804FA5"}}>{formater.format(total)}</span>
                </div>


                <div style={{backgroundColor:"#FFF",padding:0,height:"8vh",width:"60vw",borderRadius:50,overflow:"hidden",marginTop:"-3vh"}} >
                    <div style={{borderRadius:50,width:"100%",height:"100%",backgroundColor:"#FFF",overflow:"hidden"}}>
                        <div style={{borderRadius:50,width:percent+"%",height:"100%",backgroundColor:"#804FA5",background:"linear-gradient(90deg,#422164 0%, #804FA5 50%)",display:"flex",justifyContent:"flex-end",alignItems:'center',paddingRight:15}}>
                            {displayPercent>=20 && (
                                <span style={{fontFamily:"BioRhyme !important",fontWeight:"800",fontSize:"3.5vh",color:"#FFF",paddingRight:"0.5vw"}}>
                                    <span style={{marginRight:"0.6vw"}}>{Math.floor(displayPercent)}</span>%
                                </span>
                            )}
                        </div>
                    </div>
                </div>


            </div>
        </Fragment>
    )
}
